import React from 'react';

const Badge = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  className = '',
  ...props 
}) => {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'var(--font-weight-medium)',
    borderRadius: 'var(--radius-full)',
    transition: 'all var(--transition-fast)'
  };

  const variants = {
    default: {
      backgroundColor: 'var(--color-gray-100)',
      color: 'var(--color-gray-700)'
    },
    primary: {
      backgroundColor: 'var(--color-primary)',
      color: 'white'
    },
    success: {
      backgroundColor: 'var(--color-success)',
      color: 'white'
    },
    warning: {
      backgroundColor: 'var(--color-warning)',
      color: 'white'
    },
    error: {
      backgroundColor: 'var(--color-error)',
      color: 'white'
    },
    info: {
      backgroundColor: 'var(--color-info)',
      color: 'white'
    },
    secondary: {
      backgroundColor: 'var(--color-gray-500)',
      color: 'white'
    },
    outline: {
      backgroundColor: 'transparent',
      color: 'var(--color-gray-700)',
      border: '1px solid var(--color-gray-300)'
    }
  };

  const sizes = {
    sm: {
      padding: 'var(--space-1) var(--space-2)',
      fontSize: 'var(--font-size-xs)',
      minHeight: '20px'
    },
    md: {
      padding: 'var(--space-1) var(--space-3)',
      fontSize: 'var(--font-size-sm)',
      minHeight: '24px'
    },
    lg: {
      padding: 'var(--space-2) var(--space-4)',
      fontSize: 'var(--font-size-base)',
      minHeight: '32px'
    }
  };

  const badgeStyles = {
    ...baseStyles,
    ...variants[variant],
    ...sizes[size],
    ...props.style
  };

  return (
    <span
      {...props}
      style={badgeStyles}
      className={className}
    >
      {children}
    </span>
  );
};

export default Badge;
